import { stats } from "@/mocks/site";

function StatsBand() {
  return (
    <section className="w-full border-b border-background-200 bg-background-100">
      <div className="w-full px-4 py-10 md:px-8 md:py-12">
        <dl className="grid grid-cols-2 gap-6 lg:grid-cols-4">
          {stats.map((item) => (
            <div key={item.label} className="border-l-2 border-primary-400 pl-4">
              <dt className="text-xs font-label tracking-wide text-foreground-500 md:text-sm">
                {item.label}
              </dt>
              <dd className="mt-1.5 flex items-baseline gap-1">
                <span className="font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
                  {item.value}
                </span>
                <span className="text-xs text-foreground-500 md:text-sm">{item.suffix}</span>
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}

export default StatsBand;